<script>
  import _ from 'lodash';
  _.noConflict();

  const SINGLE_ELEMENT_HEIGHT = 30;
  const LAZY_RENDER_DEFAULT_CHUNK_SIZE = 100;

  export default {
    name: 'LazyRenderMixin',
    props: {
      lazyRenderChunkSize: {
        type: Number,
        default: LAZY_RENDER_DEFAULT_CHUNK_SIZE
      },
      lazyRender: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {

        // first chunk is visible by default (to prevent whitespace on first open)
        visibleChunks: {
          0: true
        }
      };
    },
    computed: {
      chunkedChoices () {
        return _.chunk(this.choices, this.lazyRenderChunkSize);
      },
      chunkHeights () {
        if (!this.lazyRender) {
          return {};
        }
        const chunkHeights = {};

        function countNestedChildren (el) {
          if (el.children) {
            return 1 + el.children.reduce((acc, item) => acc + countNestedChildren(item), 0);
          }
          return 1;
        }

        this.chunkedChoices.forEach((chunkItems, idx) => {
          chunkHeights[idx] = chunkItems.reduce((acc, item) => acc + countNestedChildren(item), 0);
        });
        return chunkHeights;
      },
      singleElementHeight () {
        return SINGLE_ELEMENT_HEIGHT;
      }
    },
    methods: {
      getObserverConfig (chunkId) {
        return {
          callback: (isVisible, entry) => this.onVisibilityChanged(isVisible, entry, chunkId),
          throttle: 300,
          throttleOptions: {
            leading: 'visible'
          }
        };
      },
      chunkIsVisible (chunkId) {
        if (!this.lazyRender) {
          return true;
        }

        return this.visibleChunks[chunkId];
      },
      onVisibilityChanged (isVisible, entry, chunkId) {
        if (!this.lazyRender) {
          return;
        }

        /*
         * do not change undefined to false to prevent recalculation of object
         * (we assume that undefined equals to false)
         * P.S. this is some kind of optimisation
         */
        if (
          isVisible && !this.visibleChunks[chunkId] ||
          !isVisible && this.visibleChunks[chunkId]
        ) {
          this.$set(this.visibleChunks, chunkId, isVisible);
        }
      },
      getCssVarsForChunk (chunkId) {
        const elementHeight = this.chunkHeights[chunkId] * this.singleElementHeight;
        return {
          '--dummy-node-height': `${elementHeight}px`,
          '--option-node-height': `${this.singleElementHeight}px`
        };
      }
    }
  };
</script>

<style>
  .m-lazy-render__lazy-dummy-node {
    height: var(--dummy-node-height);
  }

  .m-lazy-render__lazy-enabled .select-option__text {
    white-space: nowrap;

    display: block;

    min-width: 0;
  }
</style>
